import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import { connect } from 'react-redux'
import { asyncConnect } from 'redux-async-connect'
import { includes } from 'lodash'
import Modal from 'react-modal'
import Loader from 'react-loader'
import config from '../../config'
import {
  Link,
  LinkIcon
} from '../'
import * as searchActions from 'redux/modules/search'
import Styles from './CompanyProfileModal.css'

@connect(
  state => ({
    result: state.company.result,
    searching: state.company.loading,
    searched: state.company.loaded,
    error: state.company.error
  }),
  searchActions)

@CSSModules(Styles, {allowMultiple:true})
export default class CompanyProfileModal extends Component {
  static propTypes = {
    companyId: PropTypes.string,
    companyProfile: PropTypes.object,
    searching: PropTypes.bool,
    searched: PropTypes.bool,
    error: PropTypes.object,
    result: PropTypes.array,
  }

  constructor(props){
    super(props)

    this.state = {
      modalOpen: false,
    }
  }

  openModal = () =>{
    // if we weren't passed a companyProfile in props,
    // we should have been passed a companyId.
    // when the modal is open,
    // call the API to get the record for that companyId.
    this.setState({ modalOpen: true })

    if (!this.props.companyProfile) {
      this.props.company(this.props.companyId)
    }
  }

  closeModal = () =>{
    this.setState({ modalOpen: false })
  }
  //
  render() {
    // on the Companies page, we should pass a full list of company results
    // to the ScreenedCompanies component,
    // which passes individual company profiles to this component.

    // on the fund profile pages, we should pass a company_id
    // to this component.

    const companyId = this.props.companyProfile ?
      this.props.companyProfile.company_id :
      this.props.companyId

    const entry = config.pffCompanyProfiles.data[companyId]

    // if we have no entry in pffCompanyProfiles, just return the children.
    if (!entry) {
      return  <span>{this.props.children}</span>
    }

    // if we were passed a company profile, use it;
    // otherwise, check to see if the api has returned a result.
    let companyProfile = null
    if (this.props.companyProfile) {
      companyProfile = this.props.companyProfile
    } else if (this.props.result && this.props.result.length === 1) {
      companyProfile = this.props.result[0]
    }

    // if we have no profile, just return the children.
    // but with the ability to CALL for the profile from the api.
    if (!companyProfile && !this.props.searching) {
      return  <span onClick={this.openModal}>{this.props.children}</span>
    }

    const profile = entry[0]
    const types = entry[1].split(',')

    const ppIcon = require( '../../../static/images/icn-pp.svg' )
    const bordersIcon = require( '../../../static/images/icn-borders.svg' )

    const iconLabel = (title, icn=null) => {
      return (
        <div styleName='stat'>
          <div styleName='stat-count-wrapper'>
            <img
              src={icn}
              alt={title}
              styleName='stat-count'
            />
          </div>
          <div styleName='stat-label'>
            {title}
          </div>
        </div>
      )
    }

    const riskLabel = (title, styl) => {
      return (
        <div styleName='stat'>
          <div styleName='stat-count-wrapper'>
            <div styleName={'stat-count-'+styl}>
              <LinkIcon faclass='fa-exclamation-triangle fa-2x' nospace/>
            </div>
          </div>
          <div styleName={'stat-label-'+styl}>
            {title}
          </div>
        </div>
      )
    }

    return <span>
      <span onClick={this.openModal} styleName='modal-opener'>
        {this.props.children}
      </span>

      <Modal
        isOpen={this.state.modalOpen}
        onRequestClose={this.closeModal}
        contentLabel="Company profile"
        style={{
          overlay : {
            backgroundColor   : 'rgba(0, 0, 0, 0.75)'
          },
          content: {
            position                   : 'absolute',
            left                       : 0,
            right                      : 0,
            marginLeft                 : 'auto',
            marginRight                : 'auto',
            borderRadius               : 0,
            width                      : '900px',
            maxWidth                   : '90%',
            top                        : '50%',
            border                     : '0px',
            background                 : '#fff',
            overflow                   : 'visible',
            bottom                     : 'auto',
            WebkitOverflowScrolling    : 'touch',
            outline                    : 'none',
            transform                  : 'translateY(-50%)',
            padding                    : 0
          }
        }}>
        <div styleName='family-modal-wrap'>

            {
              companyProfile ?
                <div styleName='family-modal'>
                  <div styleName='family-modal-header-wrap'>
                    <div styleName='family-modal-header'>
                      {companyProfile['short_name']}
                    </div>
                  </div>
                  <div styleName='family-modal-p'>
                    {profile}
                  </div>
                  <div styleName='icon-row'>
                    {
                      companyProfile.is_pp ?
                        iconLabel('Prison industry', ppIcon) :
                        null
                    }
                    {
                      companyProfile.is_borders ?
                        iconLabel('Border industry', bordersIcon) :
                        null
                    }
                    {
                      companyProfile.is_pff_high ?
                        riskLabel('Higher risk', 'high') :
                        null
                    }
                    {
                      companyProfile.is_pff_extreme ?
                        riskLabel('Private prison operator', 'extreme') :
                        null
                    }
                  </div>
                  <div styleName='cat-flex'>
                    {
                      types.map((e, i) => {
                        return <div key={'type-' + i}  styleName='cat-item'>
                          {e.trim()}
                        </div>
                      })
                    }
                  </div>
                </div> :
                <div styleName='family-modal'>
                  <Loader
                    options={{scale: 0.70, top:'4.0rem'}}
                    loaded={ false }
                  />
                </div>
            }
          <div
            styleName='family-modal-close-wrap'
            onClick={ this.closeModal }
          >
            <div
              styleName='family-modal-close'
              className='fa fa-times'
            />
          </div>
        </div>
      </Modal>
    </span>
  }
}

